import React, { useEffect, useState, useRef } from "react";
import classes from "./login.module.css";
import { useNavigate } from "react-router-dom";
import RTKlogo from "../../images/svgs/RTKlogo";
import { auth, useAuth } from "../../scripts/app";
import { httpsCallable } from "../../scripts/functions";
import {
  signInWithEmailAndPassword,
  onAuthStateChanged,
  OAuthProvider,
  signInWithPopup,
  getAdditionalUserInfo,
  signOut
} from "firebase/auth";
import { db } from "../../scripts/app";
import { collection, query } from "firebase/firestore";

const provider = new OAuthProvider("microsoft.com");
provider.setCustomParameters({
  // Replace with your tenant GUID
  tenant: process.env.REACT_APP_MICROSOFT_TENANT_ID,
});

export default function Login() {
  const { refreshUser } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [errorStyle, setErrorStyle] = useState({ display: "none" });
  const [showPassword, setShowPassword] = useState("password");
  const [showLockOn, setShowLockOn] = useState({ display: "block" });
  const [showLockOff, setShowLockOff] = useState({ display: "none" });
  // let lockOff = document.getElementById("lock-off");
  // let lockOn = document.getElementById("lock-on");
  // let usernameInput = document.getElementById("username-input");
  // let passwordInput = document.getElementById("password-input");
  // let errorMessage = document.getElementById("error-message");
  // let login = document.getElementById("login");

  // lockOff.addEventListener("click", function () {
  //   console.log("lockoff clicked");
  //   lockOff.style.display = "none";
  //   lockOn.style.display = "block";
  //   passwordInput.setAttribute("type", "password");
  // });

  // lockOn.addEventListener("click", function () {
  //   console.log("lockon clicked");
  //   lockOn.style.display = "none";
  //   lockOff.style.display = "block";
  //   passwordInput.setAttribute("type", "text");
  // });

  const signingInRef = useRef(false);

  function handleLockOff() {
    setShowLockOff({ display: "none" });
    setShowLockOn({ display: "block" });
    setShowPassword("password");
  }
  function handleLockOn() {
    setShowLockOff({ display: "block" });
    setShowLockOn({ display: "none" });
    setShowPassword("text");
  }

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (signingInRef.current) return;
      if (user) {
        // console.log("userCredentials", user.email);
        nav("/main/launchpad");
      } else {
        // console.log("user sign in failed");
      }
    });
    return () => unsubscribe();
  }, []);

  const onLogin = (e) => {
    e.preventDefault();
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        nav("/main/launchpad");
        // console.log(user);
        // setupIdleLogout({timeout: 1, nav})
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        // console.log(errorCode, errorMessage);
        setErrorStyle({ display: "flex" });
      });
  };
  const onLoginMicrosoft = (e) => {
    e.preventDefault();
    signingInRef.current = true;
    signInWithPopup(auth, provider)
      .then((result) => {
        // User is signed in.
        // IdP data available in result.additionalUserInfo.profile.

        // Get the OAuth access token and ID Token
        const credential = OAuthProvider.credentialFromResult(result);
        const accessToken = credential.accessToken;
        const idToken = credential.idToken;
        const info = getAdditionalUserInfo(result);

        const signIn = httpsCallable('signInUser');
        signIn({ id: result.user.uid, email: result.user.email, isNewUser: info.isNewUser })
          .then(async _ => {
            // Force refresh to get updated claims
            await refreshUser();

            nav("/main/launchpad");
          })
          .catch(async error => {
            await signOut(auth);
            const errorCode = error.code;
            const errorMessage = error.message;
            // console.log(errorCode, errorMessage);
            setErrorStyle({ display: "flex" });
            signingInRef.current = false;
          });
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        // console.log(errorCode, errorMessage);
        setErrorStyle({ display: "flex" });
        signingInRef.current = false;
      });
  };

  const renderForm = () => {
    if (signingInRef.current) return <div>Logging in...</div>

    return (
      <form className={classes.loginForm} onSubmit={() => false}>
        <div className={classes.loginField}>
          <label className="" htmlFor="username">
            Username
          </label>
          <div className={classes.username}>
            <input
              type="text"
              className={classes.usernameField}
              id="username-input"
              name="username"
              placeholder="Username"
              required
              autoFocus
              tabIndex="1"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
        </div>
        <div className={classes.loginField}>
          <label className="" htmlFor="password-input">
            Password
          </label>
          <div className={classes.password}>
            <input
              className={classes.passwordField}
              id="password-input"
              name="password"
              placeholder="Password"
              required
              tabIndex="2"
              onChange={(e) => setPassword(e.target.value)}
              type={showPassword}
            />

            <svg
              id="lock-on"
              width="28"
              viewBox="0 0 24 24"
              className={classes.lockOn}
              style={showLockOn}
              onClick={handleLockOn}
            >
              <title>eye-off</title>
              <path
                fill="#555555"
                d="M11.83,9L15,12.16C15,12.11 15,12.05 15,12A3,3 0 0,0 12,9C11.94,9 11.89,9 11.83,9M7.53,9.8L9.08,11.35C9.03,11.56 9,11.77 9,12A3,3 0 0,0 12,15C12.22,15 12.44,14.97 12.65,14.92L14.2,16.47C13.53,16.8 12.79,17 12,17A5,5 0 0,1 7,12C7,11.21 7.2,10.47 7.53,9.8M2,4.27L4.28,6.55L4.73,7C3.08,8.3 1.78,10 1,12C2.73,16.39 7,19.5 12,19.5C13.55,19.5 15.03,19.2 16.38,18.66L16.81,19.08L19.73,22L21,20.73L3.27,3M12,7A5,5 0 0,1 17,12C17,12.64 16.87,13.26 16.64,13.82L19.57,16.75C21.07,15.5 22.27,13.86 23,12C21.27,7.61 17,4.5 12,4.5C10.6,4.5 9.26,4.75 8,5.2L10.17,7.35C10.74,7.13 11.35,7 12,7Z"
              />
            </svg>

            <svg
              id="lock-off"
              className={classes.lockOff}
              width="28"
              viewBox="0 0 24 24"
              style={showLockOff}
              onClick={handleLockOff}
            >
              <title>eye</title>
              <path
                fill="#555555"
                d="M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z"
              />
            </svg>
          </div>
        </div>

        <div
          className={classes.errorMessage}
          id="error-message"
          style={errorStyle}
        >
          <div className={classes.errorRoundel}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              viewBox="0 0 24 24"
            >
              <title>alert</title>
              <path
                fill="red"
                d="M13 14H11V9H13M13 18H11V16H13M1 21H23L12 2L1 21Z"
              />
            </svg>
          </div>
          Login Error, please check your credentials
        </div>

        <div className={`${classes.buttonArea} ${classes.login}`}>
          <button id="login" tabIndex="3" onClick={onLogin}>
            Login
          </button>
        </div>
        <div className={`${classes.buttonArea} ${classes.login}`}>
          <button id="login" tabIndex="3" onClick={onLoginMicrosoft}>
            Login with microsoft
          </button>
        </div>

        <div className={`${classes.buttonArea} ${classes.links}`}>
          {/* <button type="button" className="link">Create Account</button> */}

          <button
            type="button"
            tabIndex="4"
            style={{ border: "0" }}
            onClick={() => nav("/reset-password")}
            className={classes.link}
          >
            Forgotten password?
          </button>
          {/* </a> */}
        </div>
      </form>
    );
  };

  return (
    <main className={classes.statusboardLogin}>
      <RTKlogo />
      {renderForm()}
    </main>
  );
}
